import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea3b070c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-2 pb-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "未出勤のお仕事があります！", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "\n        出退勤を忘れていた場合、早急に勤怠変更申請を行ってください\n      ", -1))
const _hoisted_4 = { class: "my-3" }
const _hoisted_5 = { class: "w-100" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { class: "label-cell" }),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("col")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "勤務日", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "定刻（休憩）", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-weight-bold" }, "キャンセルの場合", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "運営事務局へお問い合わせください", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "\n        お仕事終了日から1週間ご連絡がない場合、一時的にアカウントが利用停止となります\n      ", -1))

import { computed } from "vue";
import type { PropType } from "vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import { Application } from "@/types/order/Application";
import {
  formatFromISOString,
} from "@/utils/date";


export default /*#__PURE__*/_defineComponent({
  __name: 'NotAttendedModal',
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  application: {
    type: Object as PropType<Application>,
    required: true
  }
},
  setup(__props) {

const props = __props;



const contactLink = process.env.VUE_APP_URL_CONTACT;

const attendanceCorrectionRoute = computed(() => ({
  name: "AttendanceCorrection",
  params: {
    applicationId: props.application.id.toString()
  }
}));

const displayScheduledWorkDate = computed(() => {
  return `${formatFromISOString(
    props.application.appliedStartWorkAt,
    "MM/dd(E)"
  )}`;
});

const displayScheduledWorkTime = computed(() => {
  return `${formatFromISOString(
    props.application.appliedStartWorkAt,
    "HH:mm"
  )}-${formatFromISOString(props.application.appliedFinishWorkAt, "HH:mm")}（${
    props.application.appliedHasRest
      ? `${formatFromISOString(
        props.application.appliedStartRestAt,
          "HH:mm"
        )}-${formatFromISOString(props.application.appliedFinishRestAt, "HH:mm")}`
      : "休憩なし"
  }）`;
});

return (_ctx: any,_cache: any) => {
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    visible: __props.visible,
    "hide-header": "",
    "hide-footer": "",
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    centered: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _hoisted_3,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(),
            _createElementVNode("tr", null, [
              _hoisted_7,
              _createTextVNode(),
              _createElementVNode("td", null, _toDisplayString(displayScheduledWorkDate.value), 1)
            ]),
            _createTextVNode(),
            _createElementVNode("tr", null, [
              _hoisted_8,
              _createTextVNode(),
              _createElementVNode("td", null, _toDisplayString(displayScheduledWorkTime.value), 1)
            ])
          ])
        ]),
        _createTextVNode(),
        _createVNode(AppButton, {
          block: "",
          class: "mb-3 mt-1",
          to: attendanceCorrectionRoute.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("\n        勤怠変更申請する\n      ")
          ], undefined, true),
          _: 1
        }, 8, ["to"]),
        _createTextVNode(),
        _hoisted_9,
        _createTextVNode(),
        _hoisted_10,
        _createTextVNode(),
        _createVNode(AppButtonOutline, {
          href: _unref(contactLink),
          size: "small",
          block: "",
          class: "mb-3 mt-1"
        }, {
          default: _withCtx(() => [
            _createTextVNode("\n        お問い合わせフォーム\n      ")
          ], undefined, true),
          _: 1
        }, 8, ["href"]),
        _createTextVNode(),
        _hoisted_11
      ])
    ], undefined, true),
    _: 1
  }, 8, ["visible"]))
}
}

})